module.exports = __webpack_public_path__ + "static/media/18-Camden.6660c8b1.mp4";